import { costBreakdownV2WidgetDataByWidgetIdSelector } from "./costBreakdownV2WidgetDataByWidgetIdSelector";
import { costBreakdownV2WidgetFrequencySelector } from "./costBreakdownV2WidgetFrequencySelector";
import { RootState } from "../../../../../store";
import { WidgetCosts } from "../../../../utils/types/types";
import { calculateTotalCostTrend } from "../../../../../../components/pages/utils/helpers/calculateTotalCostTrend";
import { getAverageDataByFrequency } from "../../../../utils/helpers/costBreakdown/getAverageDataByFrequency";

export const costBreakdownV2WidgetCostsSelector = (
  state: RootState,
  widgetId: string,
): WidgetCosts | undefined => {
  const widgetData = costBreakdownV2WidgetDataByWidgetIdSelector(
    state,
    widgetId,
  );
  const frequency = costBreakdownV2WidgetFrequencySelector(state, widgetId);

  const totalCost = +(widgetData?.total_cost ?? 0).toFixed(2);
  const previousPeriodTotalCost = +(
    widgetData?.previous_period_total_cost ?? 0
  ).toFixed(2);

  const totalCostTrend = calculateTotalCostTrend(
    totalCost,
    previousPeriodTotalCost,
  );

  if (!widgetData || !frequency) {
    return;
  }

  const average = getAverageDataByFrequency(frequency, widgetData);

  return {
    total: {
      cost: totalCost,
      trend: previousPeriodTotalCost > 0 ? totalCostTrend : null,
      dateDetails: widgetData?.total_cost_date_details,
    },

    previousPeriodTotal: {
      cost: previousPeriodTotalCost,
      dateDetails: widgetData?.previous_period_cost_date_details,
    },

    average,

    liveUsageTotal: {
      cost: +(widgetData?.live_usage_total_cost ?? 0)?.toFixed(2),
    },
    forecasted_costs: widgetData?.forecasted_costs,
  };
};
